<template>
    <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" width="290px" class="">
        <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="dateRangeText" prepend-icon="mdi-calendar" append-icon="mdi-chevron-down" readonly
                v-bind="attrs" v-on="on" solo class="custom-datePicker custom-select"></v-text-field>
        </template>
        <v-date-picker v-model="date" class="custom-date-picker" scrollable range>
            <v-spacer></v-spacer>
            <v-btn :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'" text @click="modal = false">
                Cancel
            </v-btn>
            <v-btn :color="$vuetify.theme.dark ? '#fff' : '#131c29'" text @click="$refs.dialog.save(date)">
                OK
            </v-btn>
        </v-date-picker>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            date: ["2022-01-01", "2023-01-01"],
            modal: false,
        }
    },
    computed: {
        dateRangeText() {
            return this.date.join(" ~ ");
        },
    },
}
</script>

<style></style>